import { TranslateService } from '@ngx-translate/core';
import { Injectable, Inject } from '@angular/core';
import { MemberProxyService } from './member-proxy.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { GlobalComponentService } from '@techmore/global';
import { OAuthError } from 'src/app/share/entity/OauthError';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { filter, delay, take, switchMap, catchError } from 'rxjs/operators';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { LoggerService } from 'src/app/share/service/logger.service';
import { TokenService } from 'src/app/share/service/token.service';
import { IS_BROWSER_TOKEN } from 'src/app/share/tokens/is-browser.token';


@Injectable()
export class SsoAuthService {

  protected _isRefreshing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    protected http: CommonHttpClientService,
    protected globalComponentService: GlobalComponentService,
    protected router: Router,
    protected memberService: MemberProxyService,
    protected translateService: TranslateService,
    @Inject(IS_BROWSER_TOKEN) protected isBrowser: boolean,
    protected loggerService: LoggerService,
    protected tokenService: TokenService,
  ) { }

  /** 登入後操作 api token 過期處理方式 */
  errorHandler = <T extends unknown>(error: any, observable: Observable<T>, observableFunc: (args?: any) => Observable<T>) => {
    if (error instanceof HttpErrorResponse) {
      const oauthError: OAuthError = Object.assign(new OAuthError(this.translateService), error.error);

      if (error.status === 401) {
        switch (error.error.subStatus) {
          case '612':
            return this.tokenService.refreshToken$(
              this.memberService.getRefreshMemberToken()(localStorage.getItem('auth_refresh_token'))
            ).pipe(
              switchMap(() => {
                return observableFunc().pipe(delay(300));
              }),
              catchError(e => {
                if (this.tokenService.canLogout()) {
                  this.tokenService.logout().then(b => {
                  }).catch(error => {
                    if (error) {
                      this.loggerService.error('', error);
                    }
                  });
                }
      
                return throwError(() => error);
              }),
            );
          case '611':
            // 認證失效 請重新登入
            if (this.tokenService.canLogout()) {
              this.tokenService.logout().then(b => {
              }).catch(error => {
                if (error) {
                  this.loggerService.error('', error);
                }
              });
            }
            break;
          case '610':
            // token 未經授權
            if (this.tokenService.canLogout()) {
              this.tokenService.logout().then(b => {
              }).catch(error => {
                if (error) {
                  this.loggerService.error('', error);
                }
              });
            }
            break;
          default:
            // 包含機器人驗證失敗的訊息也走這
            try {
              if (this.isBrowser) {
                this.globalComponentService.openErrorAlert(oauthError.getMessage());
              } else {
                this.loggerService.error(`${oauthError.getMessage()}`);
              }
            } catch (e) {
              if (this.isBrowser) {
                this.globalComponentService.openErrorAlert(`${this.http.words.undefinedError}，URL: ${error.url}`);
              } else {
                this.loggerService.error(`${this.http.words.undefinedError}，URL: ${error.url}`, e);
              }
            }
            break;
        }
      }
    }
    return throwError(error);
  }
}
